import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::index
* @see app/Http/Controllers/Admin/Queue/QueueController.php:20
* @route '/queue'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/queue',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::index
* @see app/Http/Controllers/Admin/Queue/QueueController.php:20
* @route '/queue'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::index
* @see app/Http/Controllers/Admin/Queue/QueueController.php:20
* @route '/queue'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::index
* @see app/Http/Controllers/Admin/Queue/QueueController.php:20
* @route '/queue'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::index
* @see app/Http/Controllers/Admin/Queue/QueueController.php:20
* @route '/queue'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::index
* @see app/Http/Controllers/Admin/Queue/QueueController.php:20
* @route '/queue'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::index
* @see app/Http/Controllers/Admin/Queue/QueueController.php:20
* @route '/queue'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::show
* @see app/Http/Controllers/Admin/Queue/QueueController.php:60
* @route '/queue/{source}/{id}'
*/
export const show = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/queue/{source}/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::show
* @see app/Http/Controllers/Admin/Queue/QueueController.php:60
* @route '/queue/{source}/{id}'
*/
show.url = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            source: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        source: args.source,
        id: args.id,
    }

    return show.definition.url
            .replace('{source}', parsedArgs.source.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::show
* @see app/Http/Controllers/Admin/Queue/QueueController.php:60
* @route '/queue/{source}/{id}'
*/
show.get = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::show
* @see app/Http/Controllers/Admin/Queue/QueueController.php:60
* @route '/queue/{source}/{id}'
*/
show.head = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::show
* @see app/Http/Controllers/Admin/Queue/QueueController.php:60
* @route '/queue/{source}/{id}'
*/
const showForm = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::show
* @see app/Http/Controllers/Admin/Queue/QueueController.php:60
* @route '/queue/{source}/{id}'
*/
showForm.get = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueController::show
* @see app/Http/Controllers/Admin/Queue/QueueController.php:60
* @route '/queue/{source}/{id}'
*/
showForm.head = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::bulk
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:67
* @route '/queue/bulk'
*/
export const bulk = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulk.url(options),
    method: 'post',
})

bulk.definition = {
    methods: ["post"],
    url: '/queue/bulk',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::bulk
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:67
* @route '/queue/bulk'
*/
bulk.url = (options?: RouteQueryOptions) => {
    return bulk.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::bulk
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:67
* @route '/queue/bulk'
*/
bulk.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulk.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::bulk
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:67
* @route '/queue/bulk'
*/
const bulkForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulk.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::bulk
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:67
* @route '/queue/bulk'
*/
bulkForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulk.url(options),
    method: 'post',
})

bulk.form = bulkForm

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::command
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:117
* @route '/queue/commands'
*/
export const command = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: command.url(options),
    method: 'post',
})

command.definition = {
    methods: ["post"],
    url: '/queue/commands',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::command
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:117
* @route '/queue/commands'
*/
command.url = (options?: RouteQueryOptions) => {
    return command.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::command
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:117
* @route '/queue/commands'
*/
command.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: command.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::command
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:117
* @route '/queue/commands'
*/
const commandForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: command.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::command
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:117
* @route '/queue/commands'
*/
commandForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: command.url(options),
    method: 'post',
})

command.form = commandForm

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::retry
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:25
* @route '/queue/failed/{uuid}/retry'
*/
export const retry = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

retry.definition = {
    methods: ["post"],
    url: '/queue/failed/{uuid}/retry',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::retry
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:25
* @route '/queue/failed/{uuid}/retry'
*/
retry.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return retry.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::retry
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:25
* @route '/queue/failed/{uuid}/retry'
*/
retry.post = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::retry
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:25
* @route '/queue/failed/{uuid}/retry'
*/
const retryForm = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::retry
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:25
* @route '/queue/failed/{uuid}/retry'
*/
retryForm.post = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

retry.form = retryForm

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::destroy
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:40
* @route '/queue/{source}/{id}'
*/
export const destroy = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/queue/{source}/{id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::destroy
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:40
* @route '/queue/{source}/{id}'
*/
destroy.url = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            source: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        source: args.source,
        id: args.id,
    }

    return destroy.definition.url
            .replace('{source}', parsedArgs.source.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::destroy
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:40
* @route '/queue/{source}/{id}'
*/
destroy.delete = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::destroy
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:40
* @route '/queue/{source}/{id}'
*/
const destroyForm = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Queue\QueueActionController::destroy
* @see app/Http/Controllers/Admin/Queue/QueueActionController.php:40
* @route '/queue/{source}/{id}'
*/
destroyForm.delete = (args: { source: string | number, id: string | number } | [source: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const queue = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    bulk: Object.assign(bulk, bulk),
    command: Object.assign(command, command),
    retry: Object.assign(retry, retry),
    destroy: Object.assign(destroy, destroy),
}

export default queue